import React from "react";
import QRCode from "react-qr-code";

export function OtpBadge({ code, title, hint }) {
  return (
    <div data-testid="otp-badge" className="mt-2 mb-3 p-3.5 rounded-2xl bg-[#F3E8FF] border border-[#9333EA]/30">
      <p className="text-[13px] font-black text-[#9333EA] text-right mb-2">{title}</p>
      <div className="flex flex-row-reverse items-center gap-3.5">
        <div className="p-1.5 bg-white rounded-lg shrink-0">
          <QRCode value={String(code)} size={82} />
        </div>
        <div className="flex-1">
          <p className="text-3xl font-black text-[#161629] text-center tracking-[0.4em]">{code}</p>
          <p className="text-[11px] text-[#6B7280] text-center mt-1 leading-4">{hint}</p>
        </div>
      </div>
    </div>
  );
}
